import { AgentInLenderContext } from '@nemuru-eng/js-api-client';

import { StoredCredentialLabelSuffix } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/components/AddOrEditAgentInLenderContextCredentialsDialog/components/StoredCredentialLabelSuffix';
import { isStoredCredentialField } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/storedCredentialFieldFlags';
import { PlatformCredentialField } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialFieldConfig';

interface StoredCredentialFieldLabelProps {
  labelSuffix?: JSX.Element;
}

const storedLabelProps = (): StoredCredentialFieldLabelProps => ({
  labelSuffix: <StoredCredentialLabelSuffix />,
});

export const getStoredCredentialFieldLabelProps = (
  platformField: PlatformCredentialField,
  agentInLenderContext?: AgentInLenderContext,
): StoredCredentialFieldLabelProps =>
  isStoredCredentialField(platformField, agentInLenderContext) ? storedLabelProps() : {};

export const getStoredArticleTypeLabelProps = (
  agentInLenderContext?: AgentInLenderContext,
): StoredCredentialFieldLabelProps => (agentInLenderContext?.articleType ? storedLabelProps() : {});
